import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { CHAT_ENABLED } from '../../../base/flags/constants';
import { getFeatureFlag } from '../../../base/flags/functions';
import { IconReply } from '../../../base/icons/svg';
import { getParticipantById } from '../../../base/participants/functions';
import Button from '../../../base/ui/components/web/Button';
import { BUTTON_TYPES } from '../../../base/ui/constants.any';
import { handleLobbyChatInitialized, openChat } from '../../actions.web';
import Icon from "../../../base/icons/components/Icon";
import { isMobileBrowser } from "../../../base/environment/utils";
import { close as closeParticipantsPane } from "../../../participants-pane/actions.any";
const useStyles = makeStyles()(theme => {
    return {
        replyButton: {
            padding: 0,
            color: 'rgba(0, 107, 224, 1)',
            backgroundColor: "transparent",
            fontFamily: 'Lato SemiBold',
            fontWeight: 'normal',
            fontSize: '13px',
            lineHeight: '16px',
            '&:hover': {
                backgroundColor: "transparent"
            },
            '&:not(:disabled)': {
                '&:hover': {
                    backgroundColor: 'transparent'
                },
                '&:active': {
                    backgroundColor: 'transparent'
                }
            },
            '&.is-mobile': {
                padding: 0,
                fontSize: '14px',
                lineHeight: '17px',
                height: 'initial',
            }
        }
    };
});
const PrivateMessageButton = ({ participantID, isLobbyMessage, visible }) => {
    const { classes } = useStyles();
    const dispatch = useDispatch();
    const participant = useSelector((state) => getParticipantById(state, participantID));
    const isVisible = useSelector((state) => getFeatureFlag(state, CHAT_ENABLED, true)) ?? visible;
    const isParticipantPaneOpen = useSelector((state) => state['features/participants-pane'].isOpen);
    const { t } = useTranslation();
    const handleClick = useCallback(() => {
        if (isLobbyMessage) {
            dispatch(handleLobbyChatInitialized(participantID));
        }
        else {
            if (isParticipantPaneOpen) {
                dispatch(closeParticipantsPane());
            }
            dispatch(openChat(participant));
        }
    }, []);
    if (!isVisible) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { accessibilityLabel: t('toolbar.accessibilityLabel.privateMessage'), className: classes.replyButton, label: t('chat.privateMessageReply'), onClick: handleClick, type: BUTTON_TYPES.TERTIARY }),
        React.createElement(Icon, { size: isMobileBrowser() ? 17 : 14, src: IconReply })));
};
export default PrivateMessageButton;
